import { search } from 'angular-animate';

const $inject = ['$q', '$http', 'apiService'];

const locationsSearchService = function ($q, $http, apiService) {
  let service = {};
  service.get = get;
  service.getPoiFromSearchLocation = getPoiFromSearchLocation;
  service.getAirportPoi = getAirportPoi;
  service.getCarPoiFromSearchLocation = getCarPoiFromSearchLocation;
  service.getCompanyLocations = getCompanyLocations;
  service.getOriginalCompanyLocations = getOriginalCompanyLocations;

  function get(params, endpoint = 'poi') {
    const apiUrl = apiService.getUrl('locations');
    if (endpoint === 'companyLocations') {
      return getCompanyLocations();
    } else {
      return $http.get(apiUrl, { params: params }).then((response) => {
        return response.data;
      });
    }
  }

  function getPoiFromSearchLocation(searchLocation) {
    return _.extend({}, searchLocation, {
      Title: searchLocation.Name ? searchLocation.Name : searchLocation.Location ? searchLocation.Location : '',
      City: {
        Code: searchLocation.Code,
      },
    });
  }
  function getCarPoiFromSearchLocation(searchLocation) {
    return _.extend({}, searchLocation, {
      Title: searchLocation.Name ? searchLocation.Name : searchLocation.Location ? searchLocation.Location : '',
      Iata: searchLocation.Code,
      City: {
        Code: searchLocation.CityCode || searchLocation.Code,
        Name: searchLocation.City,
      },
      Country: {
        Name: searchLocation.Country,
        Code: searchLocation.CountryCode,
      },
      Address: searchLocation.Location,
      Type: searchLocation.Code.length === 3 ? 'Airport' : 'Location',
    });
  }
  function getAirportPoi(airportCode) {
    return get({ term: airportCode, maxRows: 10, searchTypes: 'Airport' }).then((searchResults) => {
      let retAirport = _.find(searchResults, (option) => option.Iata === airportCode);
      return retAirport;
    });
  }

  // Because the endpoint does not use the same prefix as the other endpoints, I replace the /poi with an empty string
  function getCompanyLocations() {
    const apiUrl = apiService.getUrl('locations').replace('/poi', '') + '/companyLocations';
    return $http.get(apiUrl, {}).then((response) => {
      return response.data;
    });
  }

  function getOriginalCompanyLocations() {
    return service.originalCompanyLocations;
  }

  return service;
};

locationsSearchService.$inject = $inject;

export default locationsSearchService;



// WEBPACK FOOTER //
// ./src/services/locationsSearchService.js